import React from 'react';
import { useLanguage } from '../i18n';
import PublicLayout from '../components/PublicLayout';
import { LeafIcon, HeartIcon, MedalIcon, PeopleIcon } from '../components/brand/Icons';

export default function AboutPage() {
  const { t } = useLanguage();
  const values = [
    { Icon: LeafIcon, label: t('valNatural') },
    { Icon: HeartIcon, label: t('valBetterChoice') },
    { Icon: MedalIcon, label: t('valQuality') },
    { Icon: PeopleIcon, label: t('valTrust') },
  ];
  return (
    <PublicLayout>
      <section className="max-w-5xl mx-auto px-6 lg:px-10 py-24 md:py-32" data-testid="about-page">
        <p className="eyebrow mb-6">{t('navAbout')}</p>
        <h1 className="h-display text-5xl md:text-7xl mb-8 max-w-3xl">
          {t('philosophyBody')}
        </h1>

        <div className="grid md:grid-cols-12 gap-12 mt-20">
          <div className="md:col-span-5">
            <p className="eyebrow mb-3">{t('missionTitle')}</p>
            <p className="font-playfair italic text-3xl md:text-4xl leading-tight text-[#1A1A1A]">
              "{t('missionBody')}"
            </p>
          </div>
          <div className="md:col-span-7 space-y-8 text-base text-[#1A1A1A]/70 leading-relaxed">
            <p>{t('visionBody')}</p>
            <div>
              <p className="eyebrow mb-3">{t('philosophyTitle')}</p>
              <p>{t('philosophyBody')}</p>
            </div>
          </div>
        </div>

        <div className="mt-24 grid grid-cols-2 md:grid-cols-4 gap-8">
          {values.map(({Icon, label}, i) => (
            <div key={i} className="border-t border-[#1A1A1A]/15 pt-6">
              <div className="text-[#556B2F] mb-3"><Icon /></div>
              <p className="text-sm font-semibold text-[#1A1A1A]">{label}</p>
            </div>
          ))}
        </div>
      </section>
    </PublicLayout>
  );
}
